<app-header-breadcrumb></app-header-breadcrumb>


<div class="p-grid p-justify-center">
    <div class="row" style="width: 100%;">
        <div class="col-6 text-right tituloSeccion">Portal de empleados </div>
     <div class="col-6 text-right"><button class="btn btn-primary" (click)="employeeLeaveAction($event,0)">Por defecto</button>  </div>
    </div>
  
    <div class="p-col-12 col-12 w-96">
        <p-table [(selection)]="selectedEmpleados" [value]="empleados">
            <ng-template pTemplate="header">
                <tr>
                    <!-- <th style="width: 3rem">
                        <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                    </th> -->
                    <th>Empleado</th>
                    <th>Whats app</th>
                    <th>Departamento</th>
                    <th>Email (obligatorio para usar Portal del empleado)</th>
                    <th style="width: 5%; text-align: right;"></th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-empleado>
                <tr>
                    <!-- <td>
                        <p-tableCheckbox [value]="empleado"></p-tableCheckbox>
                    </td> -->
                    <td><i *ngIf="empleado.invitado" class="pi pi-check"></i>{{empleado.empleado}}</td>
                    <td>{{empleado.telefonomovil}}</td>
                    <td>
                        {{clientdepartmentMap[empleado.idClient_department]}}
                        <!-- <p-dropdown placeholder="Seleccione" id="idClient_department" [options]="departmentList"
                            [(ngModel)]="empleado.idClient_department" [showClear]="false"
                            (onChange)="onChangeEmp(empleado.idEmpleado,$event)"></p-dropdown> -->
                        <!-- {{empleado.idEmpleado}} -->
                    </td>
                    <td>{{empleado.email}}</td>
                    <td>
                        <i class="pi pi-user-edit" style="font-size: 2rem" (click)="employeeLeaveAction($event,empleado.idEmpleado)"></i>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>

<p-toast position='center'></p-toast>